export const rowPerPage = 100;

export const SORT_DIRECTION_ASC = "asc";

export const defaultTableOption = {
  isInitialized: true,
  currentRowsPerPage: 10,
  data: [],
  isLoading: false,
  page: 1,
  searchValue: "",
  totalRows: 0,
  offset: 0,
  sort: {
    field: "",
    direction: "",
  },
};
